// Reading saved step records (Learner Work and Response Policy v1 §4).
//
// New writes are `thuto-step-response-v2`: an ordered submission history plus
// the current response. Older attempts hold the bare response. Screens only
// ever see the current canonical response; the history is the gateway's.

export const V2 = "thuto-step-response-v2";

export const isV2 = (record) => record?.format === V2;

// The response a screen restores from: the latest submission, or a legacy
// response as it was saved.
export const currentResponse = (record) => {
  if (!record) return null;
  return isV2(record) ? record.current ?? null : record;
};

export const submissionsOf = (record) =>
  isV2(record) && Array.isArray(record.submissions) ? record.submissions : [];

// A stable client id for one submission. A network retry sends the same id, so
// the gateway records the submission once.
export const newSubmissionId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

// What the learner is told after a submission, from the gateway's answer only.
// `outcome` is null whenever feedback is withheld by policy.
//   right     correct
//   recorded  incorrect, but saved and moving on
//   saved     no judgement (open work, or feedback withheld), moving on
//   wrong     incorrect, try again (correct-until-correct)
//   again     not complete, feedback withheld
export const feedbackKind = ({ outcome, moved }) => {
  if (outcome === "correct") return "right";
  if (moved) return outcome === "incorrect" ? "recorded" : "saved";
  return outcome === "incorrect" ? "wrong" : "again";
};
